import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

// LAZYLOAD IMAGE
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjQyLjA3IDgwOS4xMyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNlZGVkZWQ7fTwvc3R5bGU+PC9kZWZzPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjEyNDIuMDciIGhlaWdodD0iODA5LjEzIiByeD0iMTAiLz48L3N2Zz4=',
  loading: 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjQyLjA3IDgwOS4xMyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNlZGVkZWQ7fTwvc3R5bGU+PC9kZWZzPjxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjEyNDIuMDciIGhlaWdodD0iODA5LjEzIiByeD0iMTAiLz48L3N2Zz4=',
  attempt: 1
})

// VUE META
import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

// SKELETON LOADING
import VueSkeletonLoading from 'vue-skeleton-loading';
Vue.use(VueSkeletonLoading)

// FIREBASE
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'
const firebaseConfig = {
  apiKey: process.env.API_KEY,
  authDomain: process.env.AUTH_DOMAIN,
  databaseURL: process.env.DATABASE_URL,
  projectId: "vue-project-jr",
  storageBucket: "vue-project-jr.appspot.com",
  messagingSenderId: process.env.MESSAGE_SENDER,
  appId: process.env.APPID
};
firebase.initializeApp(firebaseConfig)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
